import React from 'react';
import { Grid } from '@material-ui/core';
import MainHeader from '../../components/MainHeader';
import Title from '../../components/Title';
import MainContainer from '../Reports/components/MainContainer';
import IntegrationLinkBox from './components/IntegrationLinkBox';
import flowiseImg from '../../assets/FlowiseAI-Logo.png';
import typebotImg from '../../assets/typebot.png';

const Integrations = () => {
  return (
    <MainContainer>
      <MainHeader>
        <Title>Integrações</Title>
      </MainHeader>
      <Grid container spacing={4} sx={{ overflowY: 'unset' }}>
        {/* FLOWISE */}
        <Grid item xs={3}>
          <IntegrationLinkBox
            title="FlowIse"
            link="/integrations/flowise"
            customStyle={{ marginTop: '55px' }}
            img={flowiseImg}
          />
        </Grid>
        {/* TypeBot Iframe */}
        <Grid item xs={3}>
          <IntegrationLinkBox
            title="Typebot - Iframe"
            link="/integrations/typebotiframe"
            customStyle={{ marginTop: '55px' }}
            img={typebotImg}
          />
        </Grid>
        {/* Añadir otras integraciones aquí */}
      </Grid>
    </MainContainer>
  );
};

export default Integrations;
